import React, { FunctionComponent, useContext } from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import { linkToMedigapWaiverStateInfo } from "../../../helpers/CONSTANTS";
import { AppContext } from "../../../app/store";
import {
  AnalyticsActionType,
  TealiumEventProps,
} from "../../../app/contexts/Analytics/types";

const MedigapWaiverStateLinks: FunctionComponent<TealiumEventProps> = ({
  event_action,
  event_label,
}: TealiumEventProps) => {
  const {
    state: { language },
    dispatch,
  } = useContext(AppContext);

  const waiverStateLink = (stateName: string): JSX.Element => (
    <a
      href={linkToMedigapWaiverStateInfo(language, stateName)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() =>
        dispatch({
          type: AnalyticsActionType.SEND_TEALIUM_EVENT,
          settings: {
            event_action,
            event_label: `${event_label}${stateName}`,
          },
        })
      }
    >
      {stateName}
    </a>
  );

  return (
    <FormattedMessage
      tagName="p"
      id="medigap.help.waiver_state_links"
      values={{
        maLink: waiverStateLink("Massachusetts"),
        miLink: waiverStateLink("Minnesota"),
        wiLink: waiverStateLink("Wisconsin"),
      }}
    />
  );
};

export default MedigapWaiverStateLinks;
